<template>
  <div>
    <div style="width:100%;">
      <member-banner></member-banner>
    </div>
    <div class="pro-info-pot">
      <div class="pro-info-cup">
        <div class="pro-name">
          <span class="pro-name-info">{{member.name}}</span>
        </div>
        <div class="pro-info">
          <el-row :gutter="20">
            <el-col :span="18">
              <div class="info-info">
                <p v-html=member.summery></p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-owner">
                <div>
                  <img :src="member.path" alt="" height="80" width="180">
                  <h4>{{member.name}}</h4>
                  <div>{{member.title}}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import memberBanner from './memberBanner';
// import { viewOneMembers } from '@/api/frontMembers';
export default {
  data() {
    return {
      member: {
        name: '',
        title: '',
        summary: '',
        path: '',
        id: '',
        time: ''
      },
      memberObj: null
    };
  },
  components: {
    memberBanner
  },
  created() {
    // this.getMemberInfo(this.$route.params.mid);
  },
  methods: {
    // getMemberInfo(mid) {
    //   viewOneMembers({ orgId: mid }).then(res => {
    //     this.member.name = res.data.orgName;
    //     this.member.title = res.data.orgTypeName;
    //     this.member.summary = res.data.orgText;
    //     this.member.path = res.data.orgImg;
    //     this.member.id = res.data.orgId;
    //     this.member.time = res.data.orgAddTime;
    //   });
    // }
  }
};
</script>
<style scoped>
.pro-info-pot {
  width: 100%;
  min-height: 600px;
}
.pro-name {
  height: 60px;
  color: #fff;
  background-color: #707070;
  font-size: 26px;
  padding: 20px 0 0 20px;
}
.pro-info-cup {
  width: 80%;
  margin: 0 auto;
}
.pro-info {
  width: 95%;
  margin: 20px auto 10px;
}
.info-info {
  height: 500px;
  padding: 0 10px 0;
}
.info-owner {
  height: 500px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/members/memeberInfo.vue